
import { MapContainer, LayersControl, TileLayer, useMap, useMapEvents } from "react-leaflet";
import { useEffect, useState, useRef } from 'react';

import L from "leaflet"
import MarkerClusterGroup from 'react-leaflet-markercluster';

import { backendService } from '../../Services/backend.service';

import _ from "lodash"




export default function FireMarker(props) {
    const map = useMap()
    const [jsonDataFire, setJsonDataFire] = useState(null)
    // const [latestDate, setLatestDate] = useState(null)
    const [apiCallsFinished, setApiCallsFinished] = useState(false)

    const COLORS_MARKER = [
        "#ec1a18",
        "#f05a1a",
        "#f38c1c",
        "#f6c61e",
        "#F7EC1E",
        "#EAE84F",
        "#D9D583",
        "#C8C1BD"
    ]

    useEffect(() => {
        // Gets current date and fire geojson
        backendService.getFires()
            .then((fires) => { setJsonDataFire(fires) })
            .catch((e) => console.log(e))

    }, [])


    useEffect(() => {
        if (!map) return;
        // Adds markers to map

        // Create markers
        const markers = new L.GeoJSON(jsonDataFire, {
            pointToLayer: (feature, latlng) => {
                // const dateDiff = (new Date(latestDate["last_fire"]) - new Date(feature.properties.ACQ_DATE)) / (1000 * 60 * 60 * 24)

                const dateDiff = (new Date() - new Date(feature.properties.ACQ_DATE)) / (1000 * 60 * 60 * 24)
                const dateDiffFloored = dateDiff | 0;


                switch (dateDiffFloored) {
                    case 0:
                        return getFireMarker(COLORS_MARKER[0], latlng)
                    case 1:
                        return getFireMarker(COLORS_MARKER[1], latlng)
                    case 2:
                        return getFireMarker(COLORS_MARKER[2], latlng)
                    case 3:
                        return getFireMarker(COLORS_MARKER[3], latlng)
                    case 4:
                        return getFireMarker(COLORS_MARKER[4], latlng)
                    case 5:
                        return getFireMarker(COLORS_MARKER[5], latlng)
                    case 6:
                        return getFireMarker(COLORS_MARKER[6], latlng)
                    case 7:
                        return getFireMarker(COLORS_MARKER[7], latlng)
                    case 8:
                        return getFireMarker(COLORS_MARKER[8], latlng)
                }
            },
            // onEachFeature: (feature = {}, layer) => {}
        });
        const markersCluster = new L.MarkerClusterGroup({
            disableClusteringAtZoom: 2,
            // singleMarkerMode: true,
            // iconCreateFunction: function (cluster) {
            //     return L.divIcon({ html: '<b>Test ' + cluster.getChildCount() + '</b>' });
            // }
            iconCreateFunction: function (cluster) {
                var markers = cluster.getAllChildMarkers();
                var html = '<div class="circle">' + markers.length + '</div>';
                return L.divIcon({ html: html, className: 'mycluster', iconSize: L.point(32, 32) });
            },
            showCoverageOnHover: true, zoomToBoundsOnClick: true
        });
        let markersDeepCopy = _.cloneDeep(markers)
        markersCluster.addLayer(markersDeepCopy);

        // Switch between clusters and single markers deepending on zoom
        // Necessary to show clusters of 1 (https://github.com/Leaflet/Leaflet.markercluster/issues/391)
        function onZoom() {
            if (map.getZoom() < 11) {
                // Layer A needs to be removed before Layer B can be added. Otherwise it is not shown!
                if (map.hasLayer(markers)) {
                    map.removeLayer(markers)
                }
                if (!map.hasLayer(markersCluster)) {
                    map.addLayer(markersCluster)
                }
            } else {
                if (map.hasLayer(markersCluster)) {
                    map.removeLayer(markersCluster)
                }
                if (!map.hasLayer(markers)) {
                    console.log("adding single markers")
                    console.log(markers)
                    map.addLayer(markers)
                }

            }
        }

        map.addLayer(markersCluster)
        map.on('zoom', onZoom);

        return () => {
            // Cleanup function
            map.removeLayer(markersCluster)
            map.removeLayer(markers)
            // map.removeLayer(markersDeepCopy)
            // map.off('zoom', onZoom);
        }
    }, [jsonDataFire])

    return null;
}

function getFireMarker(color, latlng) {
    return (L.marker(latlng, {
        icon: L.divIcon({
            html: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="${color}"><path d="M0 0h24v24H0z" fill="none"/><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/></svg>`,
            className: "",
            iconAnchor: [12, 12],
        })
    })
    )
}